<script lang="ts">
  import DataFeedDateCellEdited from './DataFeedDateCellEdited.svelte';
  import DataFeedDateCellReadOnly from './DataFeedDateCellReadOnly.svelte';

  import type { DateCellKey, EntitlementRow, RowValidationErrors } from '../entitlements-table-types';

  export let row: EntitlementRow,
    cellKey: DateCellKey,
    rowValidationErrors: RowValidationErrors = {};

  $: hasValidationErrors = Object.values(rowValidationErrors).some(Boolean);
  $: editMode = Boolean(row.isEdited) || hasValidationErrors;
</script>

{#if editMode}
  <DataFeedDateCellEdited {row} {cellKey} {rowValidationErrors} on:change-row on:toggle-is-ongoing on:toggle-day-entitlement />
{:else}
  <DataFeedDateCellReadOnly {row} {cellKey} />
{/if}
